import { render, staticRenderFns } from "./ClusterModeSetting.vue?vue&type=template&id=9952cf48&scoped=true"
import script from "./ClusterModeSetting.vue?vue&type=script&lang=js"
export * from "./ClusterModeSetting.vue?vue&type=script&lang=js"
import style0 from "./ClusterModeSetting.vue?vue&type=style&index=0&id=9952cf48&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9952cf48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9952cf48')) {
      api.createRecord('9952cf48', component.options)
    } else {
      api.reload('9952cf48', component.options)
    }
    module.hot.accept("./ClusterModeSetting.vue?vue&type=template&id=9952cf48&scoped=true", function () {
      api.rerender('9952cf48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/sysParam/ClusterModeSetting.vue"
export default component.exports